import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {denim, grayscale, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  container: {flexGrow: 1},
  cardContainer: {
    marginLeft: indent * 0.8,
    marginRight: indent * 0.8,
  },
  base: {
    backgroundColor: white,
  },
  secondaryTitle: {
    fontSize: 14,
    color: denim,
    paddingLeft: indent * 0.2,
    paddingBottom: indent * 0.2,
  },
  textLabel: {
    fontSize: 14,
    paddingLeft: indent * 0.2,
    paddingTop: indent * 0.6,
  },
  noUpdateslabel: {
    fontSize: 12,
    position: 'relative',
    marginTop: indent * 1,
    paddingLeft: indent * 0.2,
    color: grayscale,
  },
});
